module.exports = __webpack_public_path__ + "static/media/Briana Shymkus Headshot.fd4d090f.jpeg";